if (!customElements.get("variant-selects")) {
  /**
   *  @class
   *  @function VariantSelects
   */
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.isDisabledFeature = this.dataset.isDisabled;
      this.updateUrl = this.dataset.updateUrl === "true";
      this.addEventListener("change", this.onVariantChange);

      this.productWrapper = this.closest(".thb-product-detail");
      this.productSlider = this.productWrapper.querySelector(".product-images");
      this.hideVariants = this.dataset.hideVariants === "true";
    }

    connectedCallback() {
      this.updateOptions();
      this.updateMasterId();
      this.setDisabled();
      this.setImageSet();
    }

    onVariantChange() {
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, "", false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantText();
      this.setDisabled();
      if (!this.currentVariant) {
        this.toggleAddButton(true, "", true);
        this.setUnavailable();
      } else {
        this.updateMedia();
        if (this.updateUrl) {
          this.updateURL();
        }
        this.updateVariantInput();
        this.renderProductInfo();
        //this.updateShareUrl();
      }
      dispatchCustomEvent("product:variant-change", {
        variant: this.currentVariant,
        sectionId: this.dataset.section,
      });
    }

    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll("fieldset"));
      this.options = [];
      this.fieldsets.forEach((fieldset, i) => {
        if (fieldset.querySelector("select")) {
          this.options.push(fieldset.querySelector("select").value);
        } else if (fieldset.querySelectorAll("input").length) {
          this.options.push(fieldset.querySelector("input:checked").value);
        }
      });
    }
    updateVariantText() {
      const fieldsets = Array.from(this.querySelectorAll("fieldset"));
      fieldsets.forEach((item, i) => {
        let label = item.querySelector(".form__label__value");
        if (label) {
          label.innerHTML = this.options[i];
        }
      });
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options
          .map((option, index) => {
            return this.options[index] === option;
          })
          .includes(false);
      });
    }

    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;

      let productSlider = this.closest(".thb-product-detail").querySelector(
          ".product-images",
        ),
        thumbnails = this.closest(".thb-product-detail").querySelector(
          "#Product-Thumbnails",
        );

      this.setActiveMedia(
        `#Slide-${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        `#Thumb-${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        productSlider,
        thumbnails,
      );
    }
    setActiveMedia(mediaId, thumbId, productSlider, thumbnails) {
      let flkty = Flickity.data(productSlider),
        activeMedia = productSlider.querySelector(mediaId);

      if (flkty && this.hideVariants) {
        if (
          productSlider.querySelector(
            ".product-images__slide.is-initial-selected",
          )
        ) {
          productSlider
            .querySelector(".product-images__slide.is-initial-selected")
            .classList.remove("is-initial-selected");
        }
        [].forEach.call(
          productSlider.querySelectorAll(
            ".product-images__slide-item--variant",
          ),
          function (el) {
            el.classList.remove("is-active");
          },
        );

        activeMedia.classList.add("is-active");
        activeMedia.classList.add("is-initial-selected");

        this.setImageSetMedia();

        if (thumbnails) {
          let activeThumb = thumbnails.querySelector(thumbId);

          if (
            thumbnails.querySelector(".product-thumbnail.is-initial-selected")
          ) {
            thumbnails
              .querySelector(".product-thumbnail.is-initial-selected")
              .classList.remove("is-initial-selected");
          }
          [].forEach.call(
            thumbnails.querySelectorAll(".product-images__slide-item--variant"),
            function (el) {
              el.classList.remove("is-active");
            },
          );

          activeThumb.classList.add("is-active");
          activeThumb.classList.add("is-initial-selected");
        }

        productSlider.reInit(this.imageSetIndex);
        productSlider.selectCell(mediaId);
      } else if (flkty) {
        productSlider.selectCell(mediaId);
      }
    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === "false") return;
      window.history.replaceState(
        {},
        "",
        `${this.dataset.url}?variant=${this.currentVariant.id}`,
      );
    }

    updateShareUrl() {
      const shareButton = document.getElementById(
        `Share-${this.dataset.section}`,
      );
      if (!shareButton) return;
      shareButton.updateUrl(
        `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`,
      );
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(
        `#product-form-${this.dataset.section}, #product-form-installment`,
      );
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(
          new Event("change", {
            bubbles: true,
          }),
        );
      });
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector(
        ".pickup-availability-wrapper",
      );

      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute("available");
        pickUpAvailability.innerHTML = "";
      }
    }

    removeErrorMessage() {
      const section = this.closest("section");
      if (!section) return;

      const productForm = section.querySelector("product-form");
      if (productForm) productForm.handleErrorMessage();
    }

    getSectionsToRender() {
      return [
        `price-${this.dataset.section}`,
        `inventory-${this.dataset.section}`,
        `sku-${this.dataset.section}`,
      ];
    }

    renderProductInfo() {
      let sections = this.getSectionsToRender();
      fetch(
        `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`,
      )
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html",
          );
          sections.forEach((id) => {
            const destination = document.getElementById(id);
            const source = html.getElementById(id);

            if (source && destination) destination.innerHTML = source.innerHTML;

            const price = document.getElementById(id);

            if (price) price.classList.remove("visibility-hidden");
          });
          this.toggleAddButton(
            !this.currentVariant.available,
            window.theme.variantStrings.soldOut,
          );
        });
    }

    toggleAddButton(disable = true, text = false, modifyClass = true) {
      const productForm = document.getElementById(
        `product-form-${this.dataset.section}`,
      );
      if (!productForm) return;

      const productTemplate = productForm
        .closest(".product-form")
        .getAttribute("template");
      const addButton = productForm.querySelector('[name="add"]');
      const addButtonText = productForm.querySelector('[name="add"] > span');

      if (!addButton) return;

      if (disable) {
        addButton.setAttribute("disabled", "disabled");
        if (text) addButtonText.textContent = text;
      } else {
        addButton.removeAttribute("disabled");
        addButton.classList.remove("loading");
        addButtonText.textContent = window.theme.variantStrings.addToCart;

        if (productTemplate?.includes("pre-order")) {
          addButtonText.textContent = window.theme.variantStrings.preOrder;
        } else {
          addButtonText.textContent = window.theme.variantStrings.addToCart;
        }
      }
      if (!modifyClass) return;
    }

    setUnavailable() {
      const button = document.getElementById(
        `product-form-${this.dataset.section}`,
      );
      const addButton = button.querySelector('[name="add"]');
      const addButtonText = button.querySelector('[name="add"] > span');
      const price = document.getElementById(`price-${this.dataset.section}`);
      if (!addButton) return;
      addButtonText.textContent = window.theme.variantStrings.unavailable;
      addButton.classList.add("sold-out");
      if (price) price.classList.add("visibility-hidden");
    }

    setDisabled() {
      if (this.isDisabledFeature != "true") {
        return;
      }
      const variant_data = this.getVariantData();

      if (variant_data) {
        let selected_options = false;
        if (this.currentVariant) {
          selected_options = this.currentVariant.options.map((value, index) => {
            return {
              value,
              index: `option${index + 1}`,
            };
          });
        } else {
          let found_option = variant_data.find((option) => {
            return option.option1 === this.options[0];
          });
          if (found_option) {
            selected_options = [
              {
                value: this.options[0],
                index: "option1",
              },
              {
                value: found_option.option2,
                index: "option2",
              },
            ];
          } else {
            return;
          }
        }
        const available_options = this.createAvailableOptionsTree(
          variant_data,
          selected_options,
        );

        this.fieldsets.forEach((fieldset, i) => {
          const fieldset_options = Object.values(available_options)[i];

          if (fieldset_options) {
            if (fieldset.querySelector("select")) {
              fieldset_options.forEach((option, option_i) => {
                if (option.isUnavailable) {
                  fieldset.querySelector(
                    "option[value=" + JSON.stringify(option.value) + "]",
                  ).disabled = true;
                } else {
                  fieldset.querySelector(
                    "option[value=" + JSON.stringify(option.value) + "]",
                  ).disabled = false;
                }
              });
            } else if (fieldset.querySelectorAll("input").length) {
              fieldset.querySelectorAll("input").forEach((input, input_i) => {
                input.classList.toggle(
                  "is-disabled",
                  fieldset_options[input_i].isUnavailable,
                );
              });
            }
          }
        });
      }
      return true;
    }

    getImageSetName(variant_name) {
      return variant_name
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/-$/, "")
        .replace(/^-/, "");
    }

    setImageSet() {
      if (!this.productSlider) return;

      let dataSetEl = this.productSlider.querySelector("[data-set-name]");
      if (dataSetEl) {
        this.imageSetName = dataSetEl.dataset.setName;
        this.imageSetIndex = this.querySelector(
          '.product-form__input[data-handle="' + this.imageSetName + '"]',
        ).dataset.index;
        this.dataset.imageSetIndex = this.imageSetIndex;
        this.setImageSetMedia();
      }
    }
    setImageSetMedia() {
      if (!this.imageSetIndex) {
        return;
      }

      let setValue = this.getImageSetName(
        this.currentVariant[this.imageSetIndex],
      );
      let group = this.imageSetName + "_" + setValue;
      let selected_set_images = this.productWrapper.querySelectorAll(
          `.product-images__slide[data-set-name="${this.imageSetName}"]`,
        ),
        selected_set_thumbs = this.productWrapper.querySelectorAll(
          `.product-thumbnail[data-set-name="${this.imageSetName}"]`,
        );

      if (this.hideVariants) {
        // Product images
        this.productWrapper
          .querySelectorAll(".product-images__slide")
          .forEach((thumb) => {
            if (thumb.dataset.group && thumb.dataset.group !== group) {
              thumb.classList.remove("is-active");
            }
          });
        selected_set_images.forEach((thumb) => {
          thumb.classList.toggle("is-active", thumb.dataset.group === group);
        });

        // Product thumbnails
        this.productWrapper
          .querySelectorAll(".product-thumbnail")
          .forEach((thumb) => {
            if (thumb.dataset.group && thumb.dataset.group !== group) {
              thumb.classList.remove("is-active");
            }
          });
        selected_set_thumbs.forEach((thumb) => {
          thumb.classList.toggle("is-active", thumb.dataset.group === group);
        });
      }
    }

    createAvailableOptionsTree(variant_data, selected_options) {
      // Reduce variant array into option availability tree
      return variant_data.reduce(
        (options, variant) => {
          // Check each option group (e.g. option1, option2, option3) of the variant
          Object.keys(options).forEach((index) => {
            if (variant[index] === null) return;

            let entry = options[index].find(
              (option) => option.value === variant[index],
            );

            if (typeof entry === "undefined") {
              // If option has yet to be added to the options tree, add it
              entry = {
                value: variant[index],
                isUnavailable: true,
              };
              options[index].push(entry);
            }

            // Check how many selected option values match a variant
            const countVariantOptionsThatMatchCurrent = selected_options.reduce(
              (count, { value, index }) => {
                return variant[index] === value ? count + 1 : count;
              },
              0,
            );

            // Only enable an option if an available variant matches all but one current selected value
            if (
              countVariantOptionsThatMatchCurrent >=
              selected_options.length - 1
            ) {
              entry.isUnavailable =
                entry.isUnavailable && variant.available
                  ? false
                  : entry.isUnavailable;
            }

            // Make sure if a variant is unavailable, disable currently selected option
            if (
              (!this.currentVariant || !this.currentVariant.available) &&
              selected_options.find(
                (option) =>
                  option.value === entry.value && index === option.index,
              )
            ) {
              entry.isUnavailable = true;
            }

            // First option is always enabled
            if (index === "option1") {
              entry.isUnavailable =
                entry.isUnavailable && variant.available
                  ? false
                  : entry.isUnavailable;
            }
          });

          return options;
        },
        {
          option1: [],
          option2: [],
          option3: [],
        },
      );
    }

    getVariantData() {
      this.variantData =
        this.variantData ||
        JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }
  customElements.define("variant-selects", VariantSelects);

  /**
   *  @class
   *  @function VariantRadios
   */
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll("fieldset"));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll("input")).find(
          (radio) => radio.checked,
        ).value;
      });
    }
    updateVariantText() {}
  }

  customElements.define("variant-radios", VariantRadios);
}
if (!customElements.get("product-slider")) {
  /**
   *  @class
   *  @function ProductSlider
   */
  class ProductSlider extends HTMLElement {
    constructor() {
      super();

      this.addEventListener("change", this.setupProductGallery);
    }
    connectedCallback() {
      this.product_container = this.closest(".thb-product-detail");
      this.thumbnail_container = this.product_container.querySelector(
        ".product-thumbnail-container",
      );
      this.video_containers = this.querySelectorAll(
        ".product-single__media-external-video--play",
      );

      this.setOptions();
      // Start Slider
      this.init();
    }
    setOptions() {
      this.hide_variants = this.dataset.hideVariants == "true";
      if (this.thumbnail_container) {
        this.thumbnails =
          this.thumbnail_container.querySelectorAll(".product-thumbnail");
      }
      this.prev_button = this.querySelector(".flickity-prev");
      this.next_button = this.querySelector(".flickity-next");
      this.options = {
        wrapAround: true,
        pageDots: true,
        contain: true,
        adaptiveHeight: true,
        initialIndex: ".is-initial-selected",
        prevNextButtons: false,
        fade: false,
        cellSelector: ".product-images__slide.is-active",
      };

      if (this.classList.contains("product-quick-images")) {
        this.options.cellAlign = "left";
        this.options.pageDots = false;
        this.options.freeScroll = true;
        this.options.wrapAround = false;
      }
    }
    init() {
      this.flkty = new Flickity(this, this.options);

      this.selectedIndex = this.flkty.selectedIndex;

      // Setup Events
      this.setupEvents();

      // Start Gallery
      this.setupProductGallery();
    }
    reInit() {
      this.flkty.destroy();

      this.setOptions();

      this.flkty = new Flickity(this, this.options);

      // Setup Events
      this.setupEvents();

      this.selectedIndex = this.flkty.selectedIndex;
    }
    setupEvents() {
      const _this = this;
      if (this.prev_button) {
        let prev = this.prev_button.cloneNode(true);
        this.prev_button.parentNode.append(prev);
        this.prev_button.remove();
        prev.addEventListener("click", (event) => {
          this.flkty.previous();
        });
        prev.addEventListener("keyup", (event) => {
          this.flkty.previous();
          event.preventDefault();
        });
      }
      if (this.next_button) {
        let next = this.next_button.cloneNode(true);
        this.next_button.parentNode.append(next);
        this.next_button.remove();
        next.addEventListener("click", (event) => {
          this.flkty.next();
        });
        next.addEventListener("keyup", (event) => {
          this.flkty.next();
          event.preventDefault();
        });
      }
      this.flkty.on("settle", function (index) {
        _this.selectedIndex = index;
      });
      this.flkty.on("change", (index) => {
        let previous_slide = this.flkty.cells[_this.selectedIndex].element,
          previous_media = previous_slide.querySelector(
            ".product-single__media",
          ),
          slide = this.flkty.cells[index].element,
          media = slide.querySelector(".product-single__media"),
          active_thumb = false;

        if (this.thumbnail_container) {
          let active_thumbs = Array.from(this.thumbnails).filter((element) =>
              element.classList.contains("is-active"),
            ),
            active_thumb = active_thumbs[index]
              ? active_thumbs[index]
              : active_thumbs[0];

          this.thumbnails.forEach((item, i) => {
            item.classList.remove("is-initial-selected");
          });
          active_thumb.classList.add("is-initial-selected");
        }

        requestAnimationFrame(() => {
          if (active_thumb) {
            if (active_thumb.offsetParent === null) {
              return;
            }
            const windowHalfHeight = active_thumb.offsetParent.clientHeight / 2,
              windowHalfWidth = active_thumb.offsetParent.clientWidth / 2;
            active_thumb.parentElement.scrollTo({
              left:
                active_thumb.offsetLeft -
                windowHalfWidth +
                active_thumb.clientWidth / 2,
              top:
                active_thumb.offsetTop -
                windowHalfHeight +
                active_thumb.clientHeight / 2,
              behavior: "smooth",
            });
          }
        });

        // Stop previous video
        if (
          previous_media.classList.contains(
            "product-single__media-external-video",
          )
        ) {
          if (previous_media.dataset.provider === "youtube") {
            previous_media.querySelector("iframe").contentWindow.postMessage(
              JSON.stringify({
                event: "command",
                func: "pauseVideo",
                args: "",
              }),
              "*",
            );
          } else if (previous_media.dataset.provider === "vimeo") {
            previous_media.querySelector("iframe").contentWindow.postMessage(
              JSON.stringify({
                method: "pause",
              }),
              "*",
            );
          }
        } else if (
          previous_media.classList.contains(
            "product-single__media-native-video",
          )
        ) {
          previous_media.querySelector("video").pause();
        }

        // Draggable.
        if (media.classList.contains("product-single__media-model")) {
          this.setDraggable(false);
        } else {
          this.setDraggable(true);
        }
      });

      if (this.thumbnail_container) {
        setTimeout(() => {
          let active_thumbs = Array.from(this.thumbnails).filter(
            (element) => element.clientWidth > 0,
          );
          active_thumbs.forEach((thumbnail, index) => {
            thumbnail.addEventListener("click", () => {
              this.thumbnailClick(thumbnail, index);
            });
          });
        });
      }
      let scrollbar = document.querySelector(
        ".product-quick-images__scrollbar>div",
      );

      if (scrollbar) {
        this.flkty.on("scroll", function (progress) {
          progress = Math.max(0, Math.min(1, progress));
          scrollbar.style.transform = "scaleX(" + progress + ")";
        });
      }
    }
    thumbnailClick(thumbnail, index) {
      [].forEach.call(this.thumbnails, function (el) {
        el.classList.remove("is-initial-selected");
      });
      thumbnail.classList.add("is-initial-selected");
      this.flkty.select(index);
    }
    setDraggable(draggable) {
      this.flkty.options.draggable = draggable;
      this.flkty.updateDraggable();
    }
    selectCell(mediaId) {
      this.flkty.selectCell(mediaId);
    }
    setupProductGallery() {
      if (!this.querySelectorAll(".product-single__media-zoom").length) {
        return;
      }
      this.setEventListeners();
    }
    buildItems() {
      this.activeImages = Array.from(
        this.querySelectorAll(
          ".product-images__slide.is-active .product-single__media-image",
        ),
      );

      return this.activeImages.map((item) => {
        let index = [].indexOf.call(
          item.parentNode.parentNode.children,
          item.parentNode,
        );

        let activelink = item.querySelector(".product-single__media-zoom");

        activelink.dataset.index = index;
        return {
          src: activelink.getAttribute("href"),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h,
        };
      });
    }
    setEventListeners() {
      this.links = this.querySelectorAll(".product-single__media-zoom");
      this.pswpElement = document.querySelectorAll(".pswp")[0];
      this.pswpOptions = {
        maxSpreadZoom: 2,
        loop: false,
        allowPanToNext: false,
        closeOnScroll: false,
        showHideOpacity: false,
        arrowKeys: true,
        history: false,
        captionEl: false,
        fullscreenEl: false,
        zoomEl: false,
        shareEl: false,
        counterEl: false,
        arrowEl: true,
        preloaderEl: true,
        getThumbBoundsFn: () => {
          const thumbnail = this.querySelector(
              ".product-images__slide.is-selected",
            ),
            pageYScroll =
              window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width,
          };
        },
      };

      this.links.forEach((link) => {
        link.addEventListener("click", (e) => this.zoomClick(e, link));
      });
    }
    zoomClick(e, link) {
      this.items = this.buildItems();
      this.pswpOptions.index = parseInt(link.dataset.index, 10);
      if (typeof PhotoSwipe !== "undefined") {
        let pswp = new PhotoSwipe(
          this.pswpElement,
          PhotoSwipeUI_Default,
          this.items,
          this.pswpOptions,
        );
        pswp.listen("firstUpdate", function () {
          pswp.listen("parseVerticalMargin", function (item) {
            item.vGap = {
              top: 50,
              bottom: 50,
            };
          });
        });
        pswp.init();
      }
      e.preventDefault();
    }
  }
  customElements.define("product-slider", ProductSlider);
}

/**
 *  @class
 *  @function ProductForm
 */
if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cartNotification = document.querySelector("cart-notification");
        this.body = document.body;

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (!this.form.reportValidity()) {
          return;
        }
        const submitButton = this.querySelector('[type="submit"]');
        if (submitButton.classList.contains("loading")) return;

        this.handleErrorMessage();

        submitButton.setAttribute("aria-disabled", true);
        submitButton.classList.add("loading");

        const selectedAddons = this.getSelectedAddons();
        
        if (selectedAddons.length > 0) {
          console.log('🔍 Found addons, adding main product + addons');
          this.addMainProductThenAddons(selectedAddons);
          return;
        }

        const config = {
          method: "POST",
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            Accept: "application/javascript",
          },
        };
        const formData = new FormData(this.form);
        formData.append(
          "sections",
          this.getSectionsToRender().map((section) => section.section),
        );
        formData.append("sections_url", window.location.pathname);
        config.body = formData;

        fetch(`${theme.routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              dispatchCustomEvent("product:variant-error", {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.description,
                message: response.message,
              });
              if (response.status === 422) {
                document.documentElement.dispatchEvent(
                  new CustomEvent("cart:refresh", {
                    bubbles: true,
                  }),
                );
              }
              this.handleErrorMessage(response.description);
              return;
            }

            this.renderContents(response);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButton.classList.remove("loading");
            submitButton.removeAttribute("aria-disabled");
          });
      }

      // 🚨 NEW: Helper method to detect selected addons
      getSelectedAddons() {
        const selectedAddonElements = document.querySelectorAll('.addon-product-single.selected');
        const addons = [];
        
        selectedAddonElements.forEach(addonElement => {
          const addonData = {
            variantId: addonElement.dataset.variantId,
            quantity: parseInt(addonElement.dataset.quantity) || 1
          };
          
          if (addonData.variantId) {
            addons.push(addonData);
          }
        });
        
        return addons;
      }

      // 🚨 NEW: Method to handle main product + addons
      addMainProductThenAddons(selectedAddons) {
        
        // First add the main product using existing flow
        const config = {
          method: "POST",
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            Accept: "application/javascript",
          },
        };
        const formData = new FormData(this.form);
        formData.append(
          "sections",
          this.getSectionsToRender().map((section) => section.section),
        );
        formData.append("sections_url", window.location.pathname);
        config.body = formData;

        fetch(`${theme.routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              console.error('🔍 Main product failed:', response.description);
              this.handleErrorMessage(response.description);
              this.finishLoading();
              return;
            }

            console.log('🔍 Main product added successfully, now adding addons...');
            
            // Main product added successfully, now add addons
            this.addAddonsSequentially(selectedAddons, 0, response);
          })
          .catch((e) => {
            console.error('🔍 Error adding main product:', e);
            this.finishLoading();
          });
      }

      // 🚨 NEW: Method to add addons one by one
      addAddonsSequentially(addons, index, lastResponse) {
        if (index >= addons.length) {
          // All addons added, finish up
          console.log('🔍 All addons added successfully!');
          this.unselectAllAddons();
          this.renderContents(lastResponse);
          this.finishLoading();
          return;
        }
        
        const addon = addons[index];
        console.log(`🔍 Adding addon ${index + 1}/${addons.length}: ${addon.variantId} (qty: ${addon.quantity})`);
        
        // Add this addon
        const config = {
          method: "POST",
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            Accept: "application/javascript",
          },
        };
        
        const formData = new FormData();
        formData.append('id', addon.variantId);
        formData.append('quantity', addon.quantity);
        formData.append(
          "sections",
          this.getSectionsToRender().map((section) => section.section),
        );
        formData.append("sections_url", window.location.pathname);
        config.body = formData;
        
        fetch(`${theme.routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              console.error(`🔍 Failed to add addon ${addon.variantId}:`, response.description);
              // Continue with next addon even if this one fails
            } else {
              console.log(`🔍 Successfully added addon ${addon.variantId}`);
            }
            
            // Add next addon
            this.addAddonsSequentially(addons, index + 1, response.status ? lastResponse : response);
          })
          .catch((e) => {
            console.error(`🔍 Error adding addon ${addon.variantId}:`, e);
            // Continue with next addon even if this one fails
            this.addAddonsSequentially(addons, index + 1, lastResponse);
          });
      }

      // 🚨 NEW: Method to unselect all addons
      unselectAllAddons() {
        const selectedAddonElements = document.querySelectorAll('.addon-product-single.selected');
        
        selectedAddonElements.forEach(addonElement => {
          addonElement.classList.remove('selected');
          
          const button = addonElement.querySelector('.addon-product-button');
          if (button) {
            button.textContent = 'Choose Color';
            button.classList.remove('selected');
          }
          
          const hasVariants = addonElement.dataset.hasVariants === 'true';
          if (hasVariants) {
            addonElement.classList.add('has-variants');
            addonElement.classList.remove('no-variants');
          } else {
            addonElement.classList.add('no-variants');
            addonElement.classList.remove('has-variants');
          }
        });
        
        console.log(`🔍 Unselected ${selectedAddonElements.length} addons`);
      }

      // 🚨 NEW: Helper method to finish loading
      finishLoading() {
        const submitButton = this.querySelector('[type="submit"]');
        submitButton.classList.remove("loading");
        submitButton.removeAttribute("aria-disabled");
      }

      getSectionsToRender() {
        return [
          {
            id: "Cart",
            section: "main-cart",
            selector: ".thb-cart-form",
          },
          {
            id: "Cart-Drawer",
            section: "cart-drawer",
            selector: ".cart-drawer",
          },
          {
            id: "cart-drawer-toggle",
            section: "cart-bubble",
            selector: ".thb-item-count",
          },
        ];
      }
      renderContents(parsedState) {
        this.getSectionsToRender().forEach((section) => {
          if (!document.getElementById(section.id)) {
            return;
          }
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector,
          );
          if (typeof CartDrawer !== "undefined") {
            new CartDrawer();
          }
          if (typeof Cart !== "undefined") {
            new Cart().renderContents(parsedState);
          }
        });

        if (document.getElementById("Cart-Drawer")) {
          document.getElementById("Cart-Drawer").open();
        }

        let product_drawer = document.getElementById("Product-Drawer");
        if (product_drawer && product_drawer.contains(this)) {
          product_drawer.classList.remove("active");

          if (!document.getElementById("Cart-Drawer")) {
            this.body.classList.remove("open-cc");
          }
        }
      }
      getSectionInnerHTML(html, selector = ".shopify-section") {
        return new DOMParser()
          .parseFromString(html, "text/html")
          .querySelector(selector).innerHTML;
      }
      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message",
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    },
  );
}

if (typeof addIdToRecentlyViewed !== "undefined") {
  addIdToRecentlyViewed();
}

// to hide and show the description block content of the collapsable row exp-13

document.addEventListener('DOMContentLoaded', function() {
  const descriptionRows = document.querySelectorAll('.description-content-collapsable-row');
  if (descriptionRows.length === 0) {
    return;
  }
  const readMoreBtns = document.querySelectorAll('.read-more-btn');
  const readLessBtns = document.querySelectorAll('.read-less-btn');
  if (readMoreBtns.length > 0) {
    readMoreBtns.forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        const preview = this.closest('.description-preview');
        const fullContent = this.closest('.description-content').querySelector('.description-full');
        preview.style.display = 'none';
        fullContent.style.display = 'block';
        this.setAttribute('aria-expanded', 'true');
      });
    });
  }
  if (readLessBtns.length > 0) {
    readLessBtns.forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        const fullContent = this.closest('.description-full');
        const preview = this.closest('.description-content').querySelector('.description-preview');
        const readMoreBtn = preview.querySelector('.read-more-btn');     
        fullContent.style.display = 'none';
        preview.style.display = 'block';
        readMoreBtn.setAttribute('aria-expanded', 'false');
      });
    });
  }
});


document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("[data-read-more]").forEach((container) => {
    const button = container.querySelector("button");

    button.addEventListener("click", function () {
      container.classList.add("expanded");
    });
  });
});




// Clear any existing event listeners and variables
if (typeof window.variantInputs !== 'undefined') {
  window.variantInputs.forEach(input => {
    input.removeEventListener('change', window.checkSelectedVariantPrice);
  });
}

window.checkSelectedVariantPrice = function() {
  const selectedVariant = document.querySelector('.product-form__radio-wrapper input[type="radio"]:checked');
  if (!selectedVariant) return;
  
  const selectedLabel = selectedVariant.nextElementSibling;
  if (!selectedLabel) return;
  
  const basePriceElement = selectedLabel.querySelector('.base_quantity_price_main');
  if (basePriceElement) {
    const basePriceStyle = window.getComputedStyle(basePriceElement).display;
    if (basePriceStyle === 'block') {
      const mainPrice = selectedLabel.querySelector('.base_quantity_price_main .var-option-main-price')?.textContent?.trim();
      const comparePrice = selectedLabel.querySelector('.base_quantity_price_main .var-option-CAP:not(.meta-compare-price)')?.textContent?.trim();
      window.handleBasePriceCase(mainPrice, comparePrice);
      return;
    }
  }
}

window.handleBasePriceCase = function(mainPrice, comparePrice) {
  const priceContainer = document.querySelector('.product-price-container .no-js-hidden');
  if (priceContainer) {
    priceContainer.style.opacity = '0';
  }
  
  setTimeout(() => {
    window.updateDiscountedPrice(mainPrice, comparePrice);
    if (priceContainer) {
      priceContainer.style.opacity = '1';
    }
  }, 1200);
}

window.updateDiscountedPrice = function(mainPrice, comparePrice) {
  const priceContainer = document.querySelector('.product-price-container .price');
  if (!priceContainer) return;
  
  const mainPriceElement = priceContainer.querySelector('.amount.base-price');
  if (mainPriceElement && comparePrice) {
    mainPriceElement.classList.add('discounted');
  }
  
  if (comparePrice) {
    const existingComparePrice = priceContainer.querySelector('del');
    if (existingComparePrice) {
      existingComparePrice.remove();
    }
    
    const comparePriceHTML = `<del><span class="amount compare-at-price">${comparePrice}</span></del>`;
    const insElement = priceContainer.querySelector('ins');
    if (insElement) {
      insElement.insertAdjacentHTML('afterend', comparePriceHTML);
    }
  }
  
  if (comparePrice) {
    const badgesContainer = priceContainer.querySelector('.badges');
    if (badgesContainer) {
      const existingSaleBadge = badgesContainer.querySelector('.badge.onsale');
      if (existingSaleBadge) {
        existingSaleBadge.remove();
      }
      
      const saleBadgeHTML = '<span class="badge onsale">Sale</span>';
      badgesContainer.insertAdjacentHTML('afterbegin', saleBadgeHTML);
    }
  }
}

window.checkSelectedVariantPrice();

window.variantInputs = document.querySelectorAll('.product-form__radio-wrapper input[type="radio"]');
window.variantInputs.forEach(input => {
  input.addEventListener('change', function() {
    setTimeout(window.checkSelectedVariantPrice, 50);
  });
});

checkSelectedVariantPrice();

const variantInputs = document.querySelectorAll('.product-form__radio-wrapper input[type="radio"]');
variantInputs.forEach(input => {
  input.addEventListener('change', function() {
    setTimeout(checkSelectedVariantPrice, 50);
  });
});
// EXP-29-base-price-update-end


/**
 * Testimonial Carousel Component
 * TikTok-style vertical video modal with horizontal thumbnail carousel
 */
// iOS video thumbnail fix - add this at the end of your testimonial carousel JS
document.addEventListener('DOMContentLoaded', function() {
  if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
    let attempts = 0;
    console.log('iphone script running');
    const maxAttempts = 15; // 15 attempts over 30 seconds (every 2 seconds)
    
    const fixIOSVideos = () => {
      attempts++;
      let videosFixed = 0;
      
      document.querySelectorAll('.testimonial-preview-video').forEach((video, i) => {
        // Skip if already fixed (has #t= in src)
        if (video.src && video.src.includes('#t=')) {
          videosFixed++;
          return;
        }
        
        const originalSrc = video.getAttribute('src') || video.querySelector('source')?.src;
        if (originalSrc && !originalSrc.includes('#t=')) {
          video.src = originalSrc + '#t=0.5';
          video.muted = true;
          video.playsInline = true;
          video.autoplay = false;
          video.load();
          videosFixed++;
          console.log(`iOS fix applied to video ${i} on attempt ${attempts}`);
        }
      });
      
      const totalVideos = document.querySelectorAll('.testimonial-preview-video').length;
      
      // Keep checking if not all videos are fixed and we haven't exceeded max attempts
      if (videosFixed < totalVideos && attempts < maxAttempts) {
        setTimeout(fixIOSVideos, 2000); // Check every 2 seconds
      } else {
        console.log(`iOS video fix completed. Fixed ${videosFixed}/${totalVideos} videos in ${attempts} attempts`);
      }
    };
    
    // Start after initial 100ms delay
    setTimeout(fixIOSVideos, 100);
  }
});


document.addEventListener('DOMContentLoaded', function() {
  
  class TestimonialCarousel {
    constructor(container) {
      this.container = container;
      this.track = container.querySelector('.testimonial-carousel-track');
      this.modal = document.getElementById('testimonial-modal');
      this.modalVideo = this.modal.querySelector('.testimonial-modal-video');
      this.progressBar = this.modal.querySelector('.testimonial-progress-fill');
      this.modalContainer = this.modal.querySelector('.testimonial-modal-container');
      
      // Control buttons
      this.muteBtn = this.modal.querySelector('.testimonial-mute-btn');
      this.closeBtns = this.modal.querySelectorAll('.testimonial-close-btn');
      this.prevBtn = this.modal.querySelector('.testimonial-nav-prev');
      this.nextBtn = this.modal.querySelector('.testimonial-nav-next');
      
      // Configuration
      this.videoUrls = this.track.dataset.videoUrls ? this.track.dataset.videoUrls.split(',') : [];
      this.enableAutoplay = this.track.dataset.enableAutoplay === 'true';
      this.currentIndex = 0;
      this.isTransitioning = false;
      this.progressInterval = null;
      this.autoplayTimers = new Map();
      this.wheelTimeout = null; 

      
      this.init();
    }
    
    init() {
      if (this.videoUrls.length === 0) return;
      
      this.setupThumbnails();
      this.setupModalEvents();
      this.setupKeyboardEvents();
      this.enableCarouselDragging();
      this.startThumbnailAutoplay();
    }
    
    setupDesktopVerticalNavigation() {
  let isDragging = false;
  let startY = 0;
  let startTime = 0;
  let accumulatedDelta = 0; // Track accumulated scroll
  const SCROLL_THRESHOLD = 30; // Reduced threshold
  const SCROLL_TIMEOUT = 150; // Faster response

  // Improved mouse wheel navigation
  this.modalContainer.addEventListener('wheel', (e) => {
    e.preventDefault();
    

    accumulatedDelta += e.deltaY;
    

    if (this.wheelTimeout) {
      clearTimeout(this.wheelTimeout);
    }
    

    this.wheelTimeout = setTimeout(() => {
      if (Math.abs(accumulatedDelta) > SCROLL_THRESHOLD) {
        if (accumulatedDelta > 0) {
          this.navigateVideo('next');
        } else {
          this.navigateVideo('prev');
        }
      }
      accumulatedDelta = 0; 
      this.wheelTimeout = null;
    }, SCROLL_TIMEOUT);
  }, { passive: false });


  this.modalContainer.addEventListener('mousedown', (e) => {
    if (e.target.closest('.testimonial-video-controls') || 
        e.target.closest('.testimonial-nav') ||
        e.target.closest('.testimonial-progress-bar')) {
      return;
    }

    isDragging = true;
    startY = e.clientY;
    startTime = Date.now();
    this.modalContainer.style.cursor = 'grab';
    e.preventDefault();
  });

  document.addEventListener('mouseup', (e) => {
    if (!isDragging) return;
    
    const endY = e.clientY;
    const endTime = Date.now();
    const deltaY = startY - endY;
    const deltaTime = endTime - startTime;
    const velocity = Math.abs(deltaY) / deltaTime; 
    
    if ((Math.abs(deltaY) > 30 && deltaTime < 400) || velocity > 0.5) {
      if (deltaY > 0) {
        this.navigateVideo('next');
      } else {
        this.navigateVideo('prev');
      }
    }
    
    isDragging = false;
    this.modalContainer.style.cursor = '';
  });
}

    
    setupThumbnails() {
      const slides = this.track.querySelectorAll('.testimonial-slide');
      
      slides.forEach((slide, index) => {
        const videoUrl = this.videoUrls[index];
        if (!videoUrl) return;
        
        // Setup click event
        slide.addEventListener('click', () => this.openModal(index));
        
        // Setup autoplay videos if enabled
        if (this.enableAutoplay) {
          const video = slide.querySelector('.testimonial-preview-video');
          if (video) {
            this.setupThumbnailVideo(video, videoUrl);
          }
        }
      });
    }
    
    setupThumbnailVideo(video, videoUrl) {
      video.src = videoUrl;
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      
      // Start 3-second autoplay loop
      video.addEventListener('loadeddata', () => {
        this.startThreeSecondLoop(video);
        video.dataset.initialized = 'true';
      });
      
      // Handle intersection observer for performance
      if ('IntersectionObserver' in window) {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // Only try to restart if video was successfully initialized
        if (video.dataset.initialized === 'true') {
          // If video is paused, try to restart the loop
          if (video.paused) {
            video.play().catch(() => {
              console.log('Intersection play failed, restarting loop...');
              this.startThreeSecondLoop(video);
            });
          }
        }
      } else {
        if (!video.paused) {
          video.pause();
        }
      }
    });
  }, { threshold: 0.5 });
  
  observer.observe(video);
}
    }
    
 startThreeSecondLoop(video) {
  // Clear any existing timer for this video
  if (this.autoplayTimers.has(video)) {
    clearTimeout(this.autoplayTimers.get(video));
    this.autoplayTimers.delete(video);
  }
  
  const playThreeSeconds = () => {
    if (video.paused) return;
    
    video.currentTime = 0;
    const timer = setTimeout(() => {
      video.pause();
      setTimeout(() => {
        if (this.enableAutoplay && video.dataset.initialized === 'true') {
          video.play().then(() => {
            playThreeSeconds();
          }).catch(() => {
            // Only fall back to static after multiple failures
          });
        }
      }, 100); 
    }, 3000); 
    
    this.autoplayTimers.set(video, timer);
  };
  
  video.play().then(() => {
    console.log('Video loop started successfully');
    playThreeSeconds();
  }).catch(() => {
    // Initial play failed - this is where static fallback is appropriate
    console.log('Initial video play failed, showing static thumbnail');
    this.showStaticThumbnail(video);
  });
}
    showStaticThumbnail(video) {
      const slide = video.closest('.testimonial-slide');
      const thumbnail = slide.querySelector('.testimonial-thumbnail');
      
      // Replace with static thumbnail
      thumbnail.innerHTML = `
        <div class="testimonial-static-thumbnail">
          <video preload="metadata">
            <source src="${video.src}" type="video/mp4">
            <source src="${video.src}" type="video/mov">
          </video>
          <div class="play-button-overlay">
            <svg width="32" height="32" viewBox="0 0 86 87" fill="none">
              <path d="M85.3493 0.830933H0.349304V86.8309H85.3493V0.830933Z" fill="url(#pattern0_211_100)"></path>
              <defs>
                <pattern id="pattern0_211_100" patternContentUnits="objectBoundingBox" width="1" height="1">
                  <use href="#image0_211_100" transform="matrix(0.00760725 0 0 0.0075188 -0.00207873 0)"></use>
                </pattern>
                <image id="image0_211_100" width="132" height="133" href="data:image/png;base64,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"></image>
              </defs>
            </svg>
          </div>
        </div>
      `;
    }
    
    enableCarouselDragging() {
      let isDragging = false;
      let startX = 0;
      let scrollLeft = 0;
      
      this.track.addEventListener('mousedown', (e) => {
        isDragging = true;
        this.track.style.cursor = 'grabbing';
        startX = e.pageX - this.track.offsetLeft;
        scrollLeft = this.track.scrollLeft;
        e.preventDefault();
      });
      
      this.track.addEventListener('mouseleave', () => {
        isDragging = false;
        this.track.style.cursor = 'grab';
      });
      
      this.track.addEventListener('mouseup', () => {
        isDragging = false;
        this.track.style.cursor = 'grab';
      });
      
      this.track.addEventListener('mousemove', (e) => {
        if (!isDragging) return;
        e.preventDefault();
        const x = e.pageX - this.track.offsetLeft;
        const walk = (x - startX) * 2;
        this.track.scrollLeft = scrollLeft - walk;
      });
      
      // Touch events for mobile
      this.track.addEventListener('touchstart', (e) => {
        startX = e.touches[0].pageX - this.track.offsetLeft;
        scrollLeft = this.track.scrollLeft;
      }, { passive: true });
      
      this.track.addEventListener('touchmove', (e) => {
        const x = e.touches[0].pageX - this.track.offsetLeft;
        const walk = (x - startX) * 2;
        this.track.scrollLeft = scrollLeft - walk;
      }, { passive: true });
    }
    
    startThumbnailAutoplay() {
      if (!this.enableAutoplay) return;
      
      const videos = this.track.querySelectorAll('.testimonial-preview-video');
      videos.forEach(video => {
        if (video.readyState >= 2) {
          this.startThreeSecondLoop(video);
        }
      });
    }
    
    setupModalEvents() {
      // Close buttons
      this.closeBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.closeModal();
        });
      });
      
      // Mute button - FIXED: Prevent event bubbling
      this.muteBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.toggleMute();
      });
      
      // Navigation buttons
      this.prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.navigateVideo('prev');
      });
      
      this.nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.navigateVideo('next');
      });
      
      // Click outside to close (desktop only)
      this.modal.addEventListener('click', (e) => {
        if (e.target === this.modal && window.innerWidth >= 768) {
          this.closeModal();
        }
      });
      
      // Video click to pause/play - NEW FUNCTIONALITY
      this.modalVideo.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.togglePlayPause();
      });
      
      // Prevent video container clicks from closing modal
      this.modal.querySelector('.testimonial-video-container').addEventListener('click', (e) => {
        e.stopPropagation();
      });
      
      // Video events - UPDATED to use setupVideoEvents method
      this.setupVideoEvents();
      
      // Custom progress bar click
      const progressBar = this.modal.querySelector('.testimonial-progress-bar');
      progressBar.addEventListener('click', (e) => {
        e.stopPropagation();
        const rect = progressBar.getBoundingClientRect();
        const pos = (e.clientX - rect.left) / rect.width;
        if (this.modalVideo.duration) {
          this.modalVideo.currentTime = pos * this.modalVideo.duration;
        }
      });

      this.setupDesktopVerticalNavigation();
      this.setupTouchEvents();
    }
    setupVideoEvents() {
      this.modalVideo.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.togglePlayPause();
      });
      
      this.modalVideo.addEventListener('loadeddata', () => this.onVideoLoaded());
      this.modalVideo.addEventListener('timeupdate', () => this.updateProgress());
      this.modalVideo.addEventListener('ended', () => this.onVideoEnded());
    }
    
    setupTouchEvents() {
      let startY = 0;
      let startTime = 0;
      
      this.modalContainer.addEventListener('touchstart', (e) => {
        startY = e.touches[0].clientY;
        startTime = Date.now();
      }, { passive: true });
      
      this.modalContainer.addEventListener('touchend', (e) => {
        const endY = e.changedTouches[0].clientY;
        const endTime = Date.now();
        const deltaY = startY - endY;
        const deltaTime = endTime - startTime;
        
        if (Math.abs(deltaY) > 50 && deltaTime < 300) {
          if (deltaY > 0) {
            this.navigateVideo('next');
          } else {
            this.navigateVideo('prev');
          }
        }
      }, { passive: true });
    }
    
    setupKeyboardEvents() {
      document.addEventListener('keydown', (e) => {
        if (!this.modal.classList.contains('active')) return;
        
        switch(e.key) {
          case 'Escape':
            this.closeModal();
            break;
          case 'ArrowUp':
            e.preventDefault();
            this.navigateVideo('prev');
            break;
          case 'ArrowDown':
            e.preventDefault();
            this.navigateVideo('next');
            break;
          case ' ':
            e.preventDefault();
            this.togglePlayPause();
            break;
          case 'm':
          case 'M':
            this.toggleMute();
            break;
        }
      });
    }
    
    openModal(index) {
      this.currentIndex = index;
      const videoUrl = this.videoUrls[index];
      
      if (!videoUrl) return;
      
      // Show modal
      this.modal.classList.add('active');
      document.body.style.overflow = 'hidden';
      document.body.classList.add('pdp-video-active');

      
      // Load video
      this.loadVideo(videoUrl);
      
      // Update navigation visibility
      this.updateNavigationVisibility();
    }
    
    closeModal() {
      console.log('💥 CLOSE MODAL CALLED!');
      console.trace('Close modal call stack:');
      
      // Stop video
      this.modalVideo.pause();
      this.modalVideo.src = '';
      
      // Clear progress
      this.clearProgress();
      
      // Hide modal
      this.modal.classList.remove('active');
      document.body.style.overflow = '';
      document.body.classList.remove('pdp-video-active'); 
      
      this.isTransitioning = false;
      
    }
    
    loadVideo(videoUrl) {
      this.modalVideo.src = videoUrl;
      this.modalVideo.load();
    }
    
    onVideoLoaded() {
      this.modalVideo.classList.remove('transitioning');
      
      this.modalVideo.muted = false;
      
      const muteIcon = this.muteBtn.querySelector('svg');
      if (muteIcon) {
        muteIcon.style.opacity = '1';
        this.muteBtn.removeAttribute('data-muted');
      }
      
      this.modalVideo.play().catch(console.error);
      this.startProgress();
    }
    

navigateVideo(direction) {
  if (this.isTransitioning || this.videoUrls.length <= 1) return;
  
  this.isTransitioning = true;
  
  // Calculate new index
  const oldIndex = this.currentIndex;
  if (direction === 'next') {
    this.currentIndex = (this.currentIndex + 1) % this.videoUrls.length;
  } else {
    this.currentIndex = (this.currentIndex - 1 + this.videoUrls.length) % this.videoUrls.length;
  }
  
  // Create new video element for incoming video
  const videoContainer = this.modal.querySelector('.testimonial-video-container');
  const currentVideo = this.modalVideo;
  const newVideo = document.createElement('video');
  
  // Setup new video
  newVideo.className = 'testimonial-modal-video';
  newVideo.setAttribute('playsinline', '');
  newVideo.setAttribute('preload', 'auto'); 
  newVideo.src = this.videoUrls[this.currentIndex];
  newVideo.muted = false;
  
  if (direction === 'next') {
    newVideo.classList.add('slide-in-from-down');
  } else {
    newVideo.classList.add('slide-in-from-up');
  }
  
  // Add new video to container
  videoContainer.appendChild(newVideo);
  
  const startAnimation = () => {
    // Start the slide animation
    setTimeout(() => {
      // Slide out current video
      if (direction === 'next') {
        currentVideo.classList.add('slide-out-up');
      } else {
        currentVideo.classList.add('slide-out-down');
      }
      
      // Slide in new video
      newVideo.classList.remove('slide-in-from-down', 'slide-in-from-up');
      newVideo.classList.add('slide-in-center');
    }, 50);
    
    // Complete transition after animation
    setTimeout(() => {
      // Remove old video
      currentVideo.remove();
      
      // Update reference to new video
      this.modalVideo = newVideo;
      
      // Setup new video events
      this.setupVideoEvents();
      
      this.isTransitioning = false;
      
      // Update mute button state
      const muteIcon = this.muteBtn.querySelector('svg');
      if (muteIcon) {
        muteIcon.style.opacity = '1';
        this.muteBtn.removeAttribute('data-muted');
      }
      this.startProgress();
    }, 400); 
  };
  
  if (newVideo.readyState >= 3) {
    newVideo.play().then(() => {
      startAnimation();
    }).catch(() => {
      startAnimation();
    });
  } else {
    const onCanPlay = () => {
      newVideo.removeEventListener('canplay', onCanPlay);
      newVideo.removeEventListener('error', onError);
      
      newVideo.play().then(() => {
        startAnimation();
      }).catch(() => {
        startAnimation();
      });
    };
    
    const onError = () => {
      newVideo.removeEventListener('canplay', onCanPlay);
      newVideo.removeEventListener('error', onError);
      startAnimation();
    };
    
    newVideo.addEventListener('canplay', onCanPlay, { once: true });
    newVideo.addEventListener('error', onError, { once: true });
    
    // Fallback: start animation after 2 seconds regardless
    setTimeout(() => {
      if (this.isTransitioning) {
        newVideo.removeEventListener('canplay', onCanPlay);
        newVideo.removeEventListener('error', onError);
        startAnimation();
      }
    }, 2000);
  }
}
    onVideoEnded() {
      // Auto-advance to next video
      setTimeout(() => {
        this.navigateVideo('next');
      }, 500);
    }
    
    toggleMute() {
      if (!this.modalVideo) return;
      
      this.modalVideo.muted = !this.modalVideo.muted;
      
      // Update mute button visual state
      const muteIcon = this.muteBtn.querySelector('svg');
      if (muteIcon) {
        if (this.modalVideo.muted) {
          muteIcon.style.opacity = '0.6';
          // Add muted indicator
          this.muteBtn.setAttribute('data-muted', 'true');
        } else {
          muteIcon.style.opacity = '1';
          this.muteBtn.removeAttribute('data-muted');
        }
      }
    }
    
    togglePlayPause() {
      if (this.modalVideo.paused) {
        this.modalVideo.play();
      } else {
        this.modalVideo.pause();
      }
    }
    
    updateProgress() {
      if (!this.modalVideo.duration) return;
      
      const progress = (this.modalVideo.currentTime / this.modalVideo.duration) * 100;
      this.progressBar.style.width = `${progress}%`;
    }
    
    startProgress() {
      this.clearProgress();
      this.progressInterval = setInterval(() => {
        this.updateProgress();
      }, 100);
    }
    
    clearProgress() {
      if (this.progressInterval) {
        clearInterval(this.progressInterval);
        this.progressInterval = null;
      }
      this.progressBar.style.width = '0%';
    }
    
    updateNavigationVisibility() {
      const showNav = this.videoUrls.length > 1;
      this.prevBtn.style.display = showNav ? 'flex' : 'none';
      this.nextBtn.style.display = showNav ? 'flex' : 'none';
    }
    
    destroy() {
      // Clear all timers
      this.autoplayTimers.forEach(timer => clearTimeout(timer));
      this.autoplayTimers.clear();
      this.clearProgress();
      
      // Remove event listeners
      document.removeEventListener('keydown', this.setupKeyboardEvents);
    }

  setupTouchEvents() {
  let startY = 0;
  let startTime = 0;
  let startX = 0;
  const SWIPE_THRESHOLD = 40; 
  const TIME_THRESHOLD = 350; 
  
  this.modalContainer.addEventListener('touchstart', (e) => {
    startY = e.touches[0].clientY;
    startX = e.touches[0].clientX;
    startTime = Date.now();
  }, { passive: true });
  
  this.modalContainer.addEventListener('touchend', (e) => {
    const endY = e.changedTouches[0].clientY;
    const endX = e.changedTouches[0].clientX;
    const endTime = Date.now();
    const deltaY = startY - endY;
    const deltaX = Math.abs(startX - endX);
    const deltaTime = endTime - startTime;
    
    if (Math.abs(deltaY) > SWIPE_THRESHOLD && 
        deltaTime < TIME_THRESHOLD && 
        Math.abs(deltaY) > deltaX) {
      if (deltaY > 0) {
        this.navigateVideo('next');
      } else {
        this.navigateVideo('prev');
      }
    }
  }, { passive: true });
}

  }
  
  // Initialize all testimonial carousels on the page
  function initTestimonialCarousels() {
    const carousels = document.querySelectorAll('.testimonial-carousel-outer');
    
    carousels.forEach(carousel => {
      new TestimonialCarousel(carousel);
    });
  }
  
  // Initialize when DOM is ready
  initTestimonialCarousels();
  
  // Re-initialize on page change (for SPA navigation)
  document.addEventListener('shopify:section:load', initTestimonialCarousels);
  
  // Handle window resize
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      const modals = document.querySelectorAll('.testimonial-modal-overlay.active');
      modals.forEach(modal => {
        const video = modal.querySelector('.testimonial-modal-video');
        if (video) {
          video.style.width = '';
          video.style.height = '';
        }
      });
    }, 250);
  });
});